<div id="wrapper">

  <!-- MOBILE MENU HEAD USER NAME -->
  <div class="left-side-menu" data-sidebar-size="condensed">
    <div class="buyerHeading d-lg-none d-xl-none d-block">
      {{userName}}
  </div>

   <!-- WEB LOGO-->
   <div class="logo-box d-none d-lg-block d-xl-block">
    <a href="javascript:;" class="logo logo-light text-center">

      <span class="logo-sm">
        <img [src]="appThemeService.appTheme.logo" alt="" height="20">
      </span>
      <span class="logo-lg">
        <img [src]="appThemeService.appTheme.logo1 || appThemeService.appTheme.logo" alt="" height="40">
      </span>
    </a>
  </div>
      <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
        <li>
          <button class="button-menu-mobile waves-effect waves-light" (click)="onToggleMobileMenu($event)">
            <i class="fe-menu"></i>
          </button>
        </li>
      </ul>
    </div>
  <!-- end Topbar -->
  <!-- Sidebar Start -->
  <div class="left-side-menu" data-sidebar-size="condensed">
    <div class="logo-box">
      <a href="javascript:;" class="logo logo-light text-center">
        <span class="logo-sm">
          <img [src]="appThemeService.appTheme.logo" alt="" height="40">
        </span>
        <span class="logo-lg">
          <img [src]="appThemeService.appTheme.logo1 || appThemeService.appTheme.logo" alt="" height="40">
        </span>
      </a>
    </div>

    <div class="slimscroll-menu" appSlimScroll *ngIf="!isCondensed" style="height: 100%;">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div class="slimscroll-menu" *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>

  </div>

  <div class="content-page px-0 px-lg-1 pt-4 mt-4">
    <div class="content">
      <!-- content -->
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
    <!-- footer -->
    <!-- <app-footer></app-footer> -->
  </div>
</div>


<ul class="d-none"  ngClass="{slide : isMenuOpen}">
  <li *ngFor="let item of menuItems;let index=index" (click)="menuItemClickHandler($event,index)">
    {{item}}
  </li>
</ul>

<ng-template #contentTemplate>
  <div id="sidebar-menu">
    <ul class="metismenu" id="sidebar-menu" #sideMenu>
      <ng-container *ngFor="let menuItem of menuItems;">
      <li *ngIf="menuItem.fn">
        <a (click)="navRoot(menuItem)" class="waves-effect side-nav-link-ref">
          <i [ngClass]="menuItem.icon"></i>
          <span> {{menuItem.linkText | translate}} </span>
        </a>
      </li>
      <li *ngIf="!menuItem.fn" routerLinkActive="menuitem-active" >
        <a routerLink="{{menuItem.route}}" class="waves-effect side-nav-link-ref">
          <i [ngClass]="menuItem.icon"></i>
          <span> {{menuItem.linkText | translate}} </span>
        </a>
      </li>
      </ng-container>
    </ul>
  </div>
  <!-- End Sidebar -->
  <div class="clearfix"></div>
  <!--- Sidemenu -->
  <!-- End Sidebar -->
  <div class="clearfix"></div>
</ng-template>
